export const StepErrorType = {
  Pending: 'Pending',
  Invalid: 'Invalid',
  Duplicated: 'Duplicated'
} as const;

export type StepErrorType = (typeof StepErrorType)[keyof typeof StepErrorType];

export const StepErrorKey = {
  IdentificationNumber: 'IdentificationNumber',
} as const;

export type StepErrorKey = (typeof StepErrorKey)[keyof typeof StepErrorKey];

export class StepError {
  key: StepErrorKey;
  message: string;
  type: StepErrorType;

  constructor(key: StepErrorKey, message: string, type: StepErrorType) {
    this.key = key;
    this.message = message;
    this.type = type;
  }

  get isBlockingError(): boolean {
    return this.type !== StepErrorType.Pending
  }
}
